import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ApplicationLayoutComponent } from '@volo/abp.ng.theme.lepton';
import { ExternalMainComponent } from './external-main/external-main.component';

const routes: Routes = [
  {
    path: '',
    component: ApplicationLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: ExternalMainComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExternalRoutingModule {}
